import type { TableDataArr } from "../../models/ITableData";

export const tableData: TableDataArr = [
  {
    id: 1,
    indicator: "Выручка, руб",
    currentDay: 500521,
    yesterday: 480521,
    thisWeek: 4805121,
  },
  {
    id: 2,
    indicator: "Наличные",
    currentDay: 300000,
    yesterday: 300000,
    thisWeek: 300000,
  },
  {
    id: 3,
    indicator: "Безналичный расчет",
    currentDay: 100000,
    yesterday: 100000,
    thisWeek: 100000,
  },
  {
    id: 4,
    indicator: "Кредитные карты",
    currentDay: 100521,
    yesterday: 100521,
    thisWeek: 100521,
  },
  {
    id: 5,
    indicator: "Средний чек, руб",
    currentDay: 1300,
    yesterday: 900,
    thisWeek: 900,
  },
  {
    id: 6,
    indicator: "Средний гость, руб",
    currentDay: 1200,
    yesterday: 800,
    thisWeek: 800,
  },
  {
    id: 7,
    indicator: "Удаления из чека (после оплаты), руб",
    currentDay: 1000,
    yesterday: 1100,
    thisWeek: 900,
  },
  {
    id: 8,
    indicator: "Удаления из чека (до оплаты), руб",
    currentDay: 1300,
    yesterday: 1300,
    thisWeek: 900,
  },
  {
    id: 9,
    indicator: "Количество чеков",
    currentDay: 34,
    yesterday: 36,
    thisWeek: 34,
  },
  {
    id: 10,
    indicator: "Количество гостей",
    currentDay: 34,
    yesterday: 36,
    thisWeek: 32,
  },
];
